import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { CopilotRepositoryProvider, useCopilotRepositoryContext } from '@bingads-webui/inline-copilot';

import { getDisplayName } from '@bingads-webui-react/hoc-utils';

const witDataService = (WrappedComponent) => {
  const Wrapper = (props) => {
    const repository = useCopilotRepositoryContext();
    const {
      fetchDisplayAdsTemplateGroups,
      fetchDisplayAdsTemplateGroupDetails,
      editDisplayAdsAssetRecommendations,
      fetchDisplayAdsTemplateDefinition,
    } = repository;

    return (
      <WrappedComponent
        {...props}
        displayTemplatesDataService={{
          fetchDisplayAdsTemplateGroups,
          fetchDisplayAdsTemplateGroupDetails,
          editDisplayAdsAssetRecommendations,
          fetchDisplayAdsTemplateDefinition,
        }}
      />);
  };

  Wrapper.displayName = `withCopilotDataService(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(Wrapper, WrappedComponent);

  return Wrapper;
};

const withCopilotDataServiceProvider = (WrappedComponent) => {
  const Wrapper = (props) => {
    const {
      perfMarker,
      serverContext,
    } = props;

    return (
      <CopilotRepositoryProvider
        campaignId="-1"
        locale={serverContext.CurrentLocale}
        recommendationType="DisplayAd"
        serverContext={serverContext}
        perfMarker={perfMarker}
      >
        <WrappedComponent {...props} />
      </CopilotRepositoryProvider>
    );
  };

  Wrapper.displayName = `withCopilotRepositoryProvider(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(Wrapper, WrappedComponent);

  return Wrapper;
};

export const withDisplayTemplatesService = (WrappedComponent) => {
  const WithDataService = witDataService(WrappedComponent);
  const WithCopilotProvider = withCopilotDataServiceProvider(WithDataService);

  return WithCopilotProvider;
};
